import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import CenterDashboardContainer from '../../containers/center/CenterDashboardContainer';
import { SideSpacer } from '../../components/common/Spacer';
import {
  CommonContainer,
  HistoryBlock,
  HistoryURL,
  HistoryActiveStyle,
} from '../../components/common/Container';
import { useHistory } from 'react-router-dom';

const DashboardPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const history = useHistory();

  if (!user || user.memberType !== 3) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer>
          <HistoryBlock>
            <HistoryURL to="/dashboard" activeStyle={HistoryActiveStyle}>
              전지점 매출 현황
            </HistoryURL>
          </HistoryBlock>
          <CenterDashboardContainer />
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default DashboardPage;

